import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';


@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkAuthAndRedirect(state);
  }

  public checkAuthAndRedirect(state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isLogin$ = this.authService.isLogin$;
    const refreshExp$ = this.authService.refreshExp$;
    const userPriv$ = this.authService.userPriv$;

    return combineLatest([isLogin$, refreshExp$, userPriv$]).pipe(
      map(([isLogin, refreshExp,userPriv]) => isLogin && refreshExp > new Date().getTime() && (userPriv=='1')),
      tap((pass) => {
        if (pass) {
          return;
        }
        this.authService.addRedirectUrl(state.url);
        this.authService.clearAuth();
      }),
      map((pass) => pass || this.router.createUrlTree(['/login'])),
    );
  }
}
